import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API_ENDPOINTS } from "../../../../util/constants";
import { actionTypes } from "../../../Auth/_redux/authRedux";
import { actions } from "../../../Dashboard/_redux/dashboardRedux";

const initialListingsState = {
  dispositionList: [],
  dispositionData: [],
  dispositionGroupId: 0,
  dispositionMeta: {},
  isNewDespositionCreated: false,
  toastInfo: {
    open: false,
    severity: "info",
    snackbarMessage: "",
  },
};

export const createDispositionGroup = createAsyncThunk(
  "dispositionSlice/createDispositionGroup",
  async (param, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_ENDPOINTS.getDispositionDetails,
        param
      );
      dispatch(
        actions.setLoadingState({
          resource: "disposition_lists",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const editDispositionGroup = createAsyncThunk(
  "dispositionSlice/editDispositionGroup",
  async (param, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.put(
        API_ENDPOINTS.getDispositionDetails + `${param.id}`,
        param
      );
      dispatch(
        actions.setLoadingState({
          resource: "disposition_lists",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const makeDispositionApi = createAsyncThunk(
  "dispositionSlice/makeDispositionApi",
  async (param, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_ENDPOINTS.makeDispositionApi,
        param
      );
      dispatch(
        actions.setLoadingState({
          resource: "disposition_data",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const fetchDispositionLists = createAsyncThunk(
  "dispositionSlice/fetchDispositionLists",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(API_ENDPOINTS.getDispositionDetails, {
        params: params,
      });
      dispatch(
        actions.setLoadingState({
          resource: "disposition_lists",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const fetchDispositionDataByID = createAsyncThunk(
  "dispositionIdSlice/fetchDispositionDataByID",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(
        API_ENDPOINTS.getDispositionDetailsById,
        {
          params,
        }
      );
      dispatch(
        actions.setLoadingState({
          resource: "disposition_data",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);
export const deleteDispositiongroups = createAsyncThunk(
  "dispositionSlice/deleteDispositiongroups",
  async (delete_param, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.delete(
        API_ENDPOINTS.deleteDispositiongroups,
        { data: delete_param }
      );
      dispatch(
        actions.setLoadingState({
          resource: "disposition_lists",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);
export const deleteSubDispositionItem = createAsyncThunk(
  "dispositionSlice/deleteSubDispositionItem",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.delete(
        API_ENDPOINTS.deleteSubDispositionItem,
        { data: id }
      );
      dispatch(
        actions.setLoadingState({
          resource: "disposition_data",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const dispositionSlice = createSlice({
  name: "dispositionSlice",
  initialState: { ...initialListingsState },

  extraReducers: (builder) => {
    builder.addCase(actionTypes.Logout, (state, action) => {
      return { ...initialListingsState };
    });

    builder.addCase(fetchDispositionLists.pending, (state) => {
      state.dispositionList = [];
    });
    builder.addCase(createDispositionGroup.pending, (state) => {
      state.dispositionData = [];
      state.isNewDespositionCreated = false;
    });
    builder.addCase(editDispositionGroup.pending, (state) => {
      state.dispositionData = [];
      state.isNewDespositionCreated = false;
    });
    builder.addCase(fetchDispositionLists.fulfilled, (state, { payload }) => {
      const { data } = payload;

      state.dispositionList = data.data;

      state.dispositionMeta = {
        ...state.dispositionMeta,
        next_page: data.next_page,
        previous_page: data.previous_page,
        total_page: data.total_page,
      };
    });
    builder.addCase(createDispositionGroup.fulfilled, (state, { payload }) => {
      const { data } = payload;
      state.isNewDespositionCreated = true;
      let copyData = data;
      copyData = {
        ...copyData,
        disposition_count_details: { disp_count: 0, sub_disp_count: 0 },
      };
      state.dispositionList = [...state.dispositionList, copyData];
    });
    builder.addCase(editDispositionGroup.fulfilled, (state, { payload }) => {
      const { data } = payload;
      state.isNewDespositionCreated = true;
      let copyData = data;
      copyData = {
        ...copyData,
        disposition_count_details: { disp_count: 0, sub_disp_count: 0 },
      };
      state.dispositionList = [...state.dispositionList, copyData];
    });
    builder.addCase(fetchDispositionLists.rejected, (state, action) => {
      state.dispositionList = [];
    });
    builder.addCase(createDispositionGroup.rejected, (state, action) => {
      state.isNewDespositionCreated = false;
    });
    builder.addCase(editDispositionGroup.rejected, (state, action) => {
      state.isNewDespositionCreated = false;
    });
  },
  reducers: {
    setDispositionToastInfo: (state, action) => {
      state.toastInfo = action.payload;
    },
  },
});
export const dispositionIdSlice = createSlice({
  name: "dispositionIdSlice",
  initialState: { ...initialListingsState },

  extraReducers: (builder) => {
    builder.addCase(actionTypes.Logout, (state, action) => {
      return { ...initialListingsState };
    });
    builder.addCase(fetchDispositionDataByID.pending, (state) => {
      state.dispositionData = [];
    });
    builder.addCase(
      fetchDispositionDataByID.fulfilled,
      (state, { payload }) => {
        const { data } = payload;
    
        if (data && data.dispositions && Array.isArray(data.dispositions)) {
          data.dispositions = data.dispositions.map((value) => {
            if (value.sub_levels.length === 0) {
              value.sub_levels.push({});
            }
            return value;
          });
    
          state.dispositionData = data.dispositions;
        } else {
          state.dispositionData = [];
        }
      }
    );
    builder.addCase(fetchDispositionDataByID.rejected, (state, action) => {
      state.dispositionData = [];
    });
  },
  reducers: {
    dispositionIdReducer: (state, action) => {
      state.dispositionGroupId = action.payload;
    },
  },
});

export const modalName = createSlice({
  name: "dispositionModalName",
  initialState: { modalName: "" },

  reducers: {
    dispositionModalReducer: (state, action) => {
      state.modalName = action.payload;
    },
  },
});
export const { dispositionModalReducer } = modalName.actions;
export const { dispositionIdReducer } = dispositionIdSlice.actions;
export const { setDispositionToastInfo } = dispositionSlice.actions;
